import type { Locale } from '../../types'

/**
 * Sentinel country value meaning "somewhere outside Indonesia".
 *
 * The address hierarchy (province/regency/district/village/postal code) is Indonesia-only data, so
 * picking this value hides those fields and leaves the street address as the only address input.
 */
export const OTHER_COUNTRY_VALUE = 'OTHER'

export function isOtherCountry(country: string | null | undefined): boolean {
  return country === OTHER_COUNTRY_VALUE
}

/** Options for the country picker, in the caller's locale. */
export function getCountryOptions(locale: Locale = 'id') {
  return [
    { label: 'Indonesia', value: 'ID' },
    { label: locale === 'id' ? 'Lainnya' : 'Other', value: OTHER_COUNTRY_VALUE },
  ]
}
